import { createFileRoute } from "@tanstack/react-router";
import { Facebook, Instagram, Mail } from "lucide-react";
import { Section } from "@alight/ui";
import { useSeo } from "../lib/seo";
import { useBlock } from "../lib/content";
import { MessageForm } from "../components/MessageForm";
import { PageIntro } from "../components/PageIntro";

export const Route = createFileRoute("/contact")({
  component: ContactPage,
});

const cardClass =
  "flex items-center gap-4 rounded-card border border-border bg-card p-5 transition-colors hover:bg-band focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary";

function ContactPage() {
  const c = useBlock("contact");
  const banners = useBlock("banners");

  useSeo({
    title: "Contact | Connect Sydney",
    description:
      "Contact Connect Sydney — expressions of interest, enquiries and feedback. Email connectsydneyministry@gmail.com or message us on Instagram and Facebook.",
    path: "/contact",
    image: banners.contactImage,
  });
  return (
    <>
      <PageIntro
        eyebrow="Get in touch"
        title="Contact us"
        description={c.intro}
        image={banners.contactImage}
        imageAlt={banners.contactImageAlt}
      />

      <Section tone="paper" spacing="lg">
        <div className="grid gap-10 lg:grid-cols-[1fr_1.4fr]">
          <div className="space-y-4">
            <h2 className="font-heading text-2xl font-extrabold text-ink">Social media & email</h2>
            <a href={c.instagramUrl} target="_blank" rel="noreferrer" className={cardClass}>
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-card bg-primary/10 text-primary">
                <Instagram className="h-5 w-5" aria-hidden />
              </span>
              <span className="min-w-0">
                <span className="block text-sm font-medium text-muted">Instagram</span>
                <span className="block truncate font-semibold text-ink">{c.instagramHandle}</span>
              </span>
            </a>
            <a href={c.facebookUrl} target="_blank" rel="noreferrer" className={cardClass}>
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-card bg-primary/10 text-primary">
                <Facebook className="h-5 w-5" aria-hidden />
              </span>
              <span className="min-w-0">
                <span className="block text-sm font-medium text-muted">Facebook</span>
                <span className="block truncate font-semibold text-ink">{c.facebookHandle}</span>
              </span>
            </a>
            <a href={`mailto:${c.email}`} className={cardClass}>
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-card bg-primary/10 text-primary">
                <Mail className="h-5 w-5" aria-hidden />
              </span>
              <span className="min-w-0">
                <span className="block text-sm font-medium text-muted">Email</span>
                <span className="block truncate font-semibold text-ink">{c.email}</span>
              </span>
            </a>
          </div>

          {/* Posts to the team inbox via POST /api/messages. */}
          <div className="rounded-card border border-border bg-card p-6 shadow-soft sm:p-8">
            <h2 className="font-heading text-2xl font-extrabold text-ink">{c.formTitle}</h2>
            <p className="mt-2 text-muted">{c.formIntro}</p>
            <div className="mt-6">
              <MessageForm source="contact" />
            </div>
          </div>
        </div>
      </Section>
    </>
  );
}
